import { css } from '@styled-system/css';
import { type FC } from 'react';

import { useAnalysisSegment } from '@/features/analysisPage/contexts/AnalysisSegmentContext';
import { useParams } from 'react-router-dom';

import { AnalysisStatsPanel } from '@/shared/components/analysis/AnalysisStatsPanel';
import { Message } from '@/shared/components/ui/Message';

import { useAnalysisStatistics } from '../hooks';

// L'onglet Statistiques est intégralement servi par getAnalysisDashboard
// (stats + séries graphiques). Le segment sera passé à la query lors de la
// migration segment-par-ids (pour l'instant : dashboard non segmenté).
export interface AnalysisPageStatisticsProps {
  /** 'vendor' : heatmap unique (mise en vente), pas de comparaison. */
  variant?: 'product' | 'vendor';
}

export const AnalysisPageStatistics: FC<AnalysisPageStatisticsProps> = ({ variant = 'product' }) => {
  const { id: analysisId } = useParams<{ id: string }>();
  // Conservé pour la migration segment-par-ids (la barre reste affichée)
  useAnalysisSegment();

  const { data, loading, error, dailyActivity, weeklyPattern, saleTimeDistribution, characteristics } =
    useAnalysisStatistics({ analysisId });

  return (
    <div className={css({ display: 'flex', flexDirection: 'column', gap: '5' })}>
      {error ? (
        <Message type="error" bordered>
          {error}
        </Message>
      ) : (
        <AnalysisStatsPanel
          data={data}
          loading={loading}
          dailyActivity={dailyActivity}
          weeklyPattern={weeklyPattern}
          characteristics={characteristics}
          saleTimeDistribution={saleTimeDistribution}
          variant={variant}
        />
      )}
    </div>
  );
};
